import { render, staticRenderFns } from "./SequenceReport.vue?vue&type=template&id=b6a4bd58&"
import script from "./SequenceReport.vue?vue&type=script&lang=js&"
export * from "./SequenceReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports